import { cacheDom } from "../utils/QuerySelectors.js"
import { getXgenProducts } from '../utils/Product.js'

const dom = {}
const qs = {
  swiper: 'data-media-swiper',
}
const qsAll = {
  sections: 'data-section-type="related-products"',
}

const initSlider = (section) => {
  const sectionSwiper = new Swiper(section.querySelector(`[${qs.swiper}]`), {
    slidesPerView: 1.5,
    spaceBetween: 12,
    grabCursor: true,
    a11y: false,
    freeMode: true,
    speed: 7000,
    loop: true,
    autoplay: {
      delay: 0.5,
      pauseOnMouseEnter: true,
      disableOnInteraction: false
    },
    breakpoints: {
      320: {
        slidesPerView: 1.5,
        spaceBetween: 12
      },
      768: {
        slidesPerView: 2.5,
      },
      1024: {
        slidesPerView: 3.5,
        spaceBetween: 16
      }
    },
    on: {
      init: function () {
        section.classList.add('!opacity-100')
      },
    },
  })
  section.querySelector(`[${qs.swiper}]`).addEventListener('mouseenter', () => {
    sectionSwiper.autoplay.stop()
  })
  section.querySelector(`[${qs.swiper}]`).addEventListener('mouseleave', () => {
    sectionSwiper.autoplay.start()
  })
}

const initSection = (section) => {
  const xgenId = section.querySelector(`[${qs.swiper}]`).dataset.xgen
  const excludeSale = section.querySelector(`[${qs.swiper}]`).dataset.excludeSale
  
  if(xgenId) {
    if(typeof getXgenPredictions != 'undefined') {
      getXgenPredictions(xgenId).then((results) => {
        const skus = results.map((result) => result.variants[0].sku).filter(Boolean)
        getXgenProducts((results) => {
          console.log('related products', results)
          const swiperWrapper = section.querySelector('.swiper-wrapper')
          const filteredResults = excludeSale == "true" ? results.filter((result) => !result.tags.includes('Sale') && !result.tags.includes('Final Sale')) : results
          filteredResults.forEach((result) => {
            result.related = true
            swiperWrapper.innerHTML +=  `
              <div class="swiper-slide">
                <div class="h-full" product-tile props='${JSON.stringify(result).replace("'", "’")}'></div>
              </div>
            `
          })
          window.setupProductTiles(swiperWrapper.querySelectorAll('[product-tile]:empty'))
          initSlider(section)
        }, skus)
      })
    }
  } else
    initSlider(section)
}

export const setupRelatedProducts = () => {
  cacheDom(dom, qs, qsAll)
  dom.sections.forEach((section) => {
    initSection(section)
  })
}